import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {Img, MainTitleDark as MainTitleDarkUI, HeadlineSmall} from 'ui';
import {Link} from 'react-router-dom';
import arrowBack from 'assets/img/arrowBack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.greyLight,
  paddingBottom: 65,
});

export const Image = styled(Img)({
  width: '100vw',
  height: 350,
});

export const Subtitle = styled(MainTitleDarkUI)({
  fontSize: 26,
  lineHeight: '28px',
  marginTop: 24,
  marginBottom: 8,
});

export const Description = styled(HeadlineSmall)({
  color: colors.grey,
});

export const MainTitleDark = styled(MainTitleDarkUI)({
  marginBottom: 16,
});

export const BackLink = styled(Link)({
  position: 'absolute',
  top: 40,
  left: 20,
  width: 32,
  height: 32,
  backgroundColor: 'transparent',
  backgroundImage: `url(${arrowBack})`,
  backgroundPosition: 'center',
});

export const Ingredients = styled('div')({
  color: colors.grey,
  fontSize: 16,
  width: '100%',
  padding: '0 20px',
  '& p > strong': {
    color: colors.black,
    fontFamily: fonts.title,
  },
});
